import React, { useState } from 'react';

type Props = {
  expressionId: string;
  currentEpsilon?: number;
  onUpdateEpsilon: (expressionId: string, epsilon: number) => void;
};

const EpsilonEditor: React.FC<Props> = ({ expressionId, currentEpsilon, onUpdateEpsilon }) => {
  const [editing, setEditing] = useState(false);
  const [input, setInput] = useState(String(currentEpsilon ?? 0.0001));

  const handleSubmit = () => {
    const value = parseFloat(input);
    if (!isNaN(value)) {
      onUpdateEpsilon(expressionId, value);
    }
    setEditing(false);
  };

  const handleCancel = () => {
    setEditing(false);
    setInput(String(currentEpsilon ?? 0.0001));
  };

  return editing ? (
    <input
      type="number"
      value={input}
      className="ml-auto w-20 text-sm border rounded px-1 py-0.5"
      autoFocus
      onChange={(e) => setInput(e.target.value)}
      onBlur={handleSubmit}
      onKeyDown={(e) => {
        if (e.key === 'Enter') {
          e.preventDefault();
          handleSubmit();
        } else if (e.key === 'Escape') {
          e.preventDefault();
          handleCancel();
        }
      }}
    />
  ) : (
    <button
      className="ml-auto text-xs text-accent hover:underline"
      title="Edit epsilon value"
      onClick={() => {
        setInput(String(currentEpsilon ?? 0.0001));
        setEditing(true);
      }}
    >
      ε
    </button>
  );
};

export default EpsilonEditor;